import { generatePath } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import { SearchLight } from "@/types/Search";
import { SearchItem } from "./SearchItem";
import { arrayMove } from "@/utils/arrayMove";

export function ActiveSearches({
  activeSearches,
  orgUuid,
  pathname,
  onDelete,
  onReorder,
}: {
  activeSearches: SearchLight[];
  orgUuid: string;
  pathname: string;
  onDelete: (searchUuid: string) => void;
  onReorder: (reorderedSearches: SearchLight[]) => void;
}) {
  function handleMoveUp(index: number) {
    if (index <= 0) return;
    const reordered = arrayMove(activeSearches, index, index - 1);
    onReorder(reordered);
  }

  function handleMoveDown(index: number) {
    if (index >= activeSearches.length - 1) return;
    const reordered = arrayMove(activeSearches, index, index + 1);
    onReorder(reordered);
  }

  return activeSearches.map((search, index) => {
    const to = generatePath(ROUTES.MENTION_DETAIL_ORGID, {
      orgUuid,
      uuid: search.uuid,
    });

    const isFirst = index === 0;
    const isLast = index === activeSearches.length - 1;

    return (
      <SearchItem
        key={search.uuid}
        to={to}
        search={search}
        orgUuid={orgUuid}
        pathname={pathname}
        onDelete={() => onDelete(search.uuid)}
        onMoveUp={isFirst ? undefined : () => handleMoveUp(index)}
        onMoveDown={isLast ? undefined : () => handleMoveDown(index)}
      />
    );
  });
}
